<app-header />

<div [class]="themeClass()" class="main-container">
  <app-side-menu />

  <div class="container">
    <main class="router-content">
      <router-outlet />
    </main>

    <app-footer />
  </div>

  <app-modal />
</div>

<app-toast-host />

@if (isLoading()) {
<div class="app-loading-overlay" aria-live="polite" aria-busy="true">
  <div class="app-loading-overlay__surface">
    <tds-spinner size="lg"></tds-spinner>
  </div>
</div>
}
